import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

import { ConfiguracoesProjeto, GenericHttpService, ParametrosService, TipoContaModel } from '..';

@Injectable()
export class TipoContaService {
  public _urlBase: string;
  public configuracao: ConfiguracoesProjeto;

  public tiposContas: TipoContaModel[];
  public tiposContasChange = new Subject<TipoContaModel[]>();
  public tiposContasErro = '';

  constructor(
    private readonly genericHttpService: GenericHttpService<TipoContaModel>,
    private readonly parametrosService: ParametrosService
  ) {}

  get urlBase() {
    this.configuracao = this.parametrosService.getConfiguracao();
    this._urlBase = this.configuracao.uri + 'tipo-conta/';

    return this._urlBase;
  }

  public getTiposConta() {
    const api = `listagem`;

    this.genericHttpService.getById(this.urlBase + api).subscribe(
      (data: any) => {
        this.tiposContas = <TipoContaModel[]>data;
        this.tiposContasErro = '';
        this.tiposContasChange.next(this.tiposContas.slice());
      },
      (error: any) => {
        this.tiposContas = [];
        this.tiposContasErro = error;
        this.tiposContasChange.next(this.tiposContas.slice());
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/service/tipo-conta.service.ts